import { useQuery } from '@gogame/query';

import { loadFavouriteMetrics } from '../sources/metrics';
import { favouriteMetrics } from './queryKeyFactory';

export const useLoadFavouriteMetrics = () => {
  return useQuery(
    favouriteMetrics(),
    (_, { signal }) => loadFavouriteMetrics({}, { signal }),
    {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
    }
  );
};
